import styled from 'react-emotion';

// @padding
// @width
export const Toggle = styled('button')`
  appearance: none;
  background-color: transparent;
  color: inherit;
  border: none;
  display: block;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  outline: none;
`;

export const FixedNavToggle = styled(Toggle)`
  height: 60px;
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NavToggleBar = styled('span')`
  display: block;
  position: absolute;
  top: 50%;
  left: 6px;
  right: 6px;
  height: 2px;
  background-color: ${props => (props.isExpanded ? 'transparent' : '#7e7990')};

  &::before,
  &::after {
    content: "";
    position: absolute;
    display: block;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #7e7990;
    transition-duration: 0.3s, 0.3s;
  }

  &::before {
    top: ${props => (props.isExpanded ? '0' : '-7px')};
    transform: ${props => (props.isExpanded ? 'rotate(45deg)' : undefined)};
    transition-property: top, transform;
  }
  &::after {
    bottom: ${props => (props.isExpanded ? '0' : '-7px')};
    transform: ${props => (props.isExpanded ? 'rotate(-45deg)' : undefined)};
    transition-property: bottom, transform;
  }
`;



// WEBPACK FOOTER //
// ../shop_main/components/toggle/style.js